import { render } from "./DsFooter.vue?vue&type=template&id=5fba1476&scoped=true"
import script from "./DsFooter.vue?vue&type=script&lang=js"
export * from "./DsFooter.vue?vue&type=script&lang=js"

import "./DsFooter.vue?vue&type=style&index=0&id=5fba1476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fba1476"]])

export default __exports__